import { render } from "./OurBranchesView.vue?vue&type=template&id=862872b6"
import script from "./OurBranchesView.vue?vue&type=script&lang=js"
export * from "./OurBranchesView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__